const CATALOG_BASE_PATH = "/catalog";

export const CATALOG_ROUTES = {
    CATALOG: CATALOG_BASE_PATH,
    CURRENT_ACCOUNT: CATALOG_BASE_PATH + "/current-account",
    STATISTICS: CATALOG_BASE_PATH + "/statistics",
    ADMIN: "/main"
};